import { MoreInfo } from './MoreInfo';

export type { TypeMoreInfoProps } from './types';
export default MoreInfo;
